<style>

</style>

<svelte:window on:resize="{drawResize}"/>

<div bind:clientWidth="{width}">
	<canvas bind:this="{canvas}" width="{width}" height="{height}"></canvas>
</div>

<script>

// 0% to 100%
export let match = 75;

let width = 0;
let height = 200;
let canvas = null;
let ctx = null;

$:{
  if (match >= 0 && match <= 100) setTimeout(paint, 100);
}


let repaint = null;
function drawResize(e) {
	clearTimeout(repaint);
	repaint = setTimeout(function() {
		paint();
	}, 100)
}


function paint() {
  if (canvas.getContext) {
		ctx = canvas.getContext("2d");
		
    // console.log("width:", width);
    // console.log("height:", height);
    
    // console.log("match percentage:", match);
    
    // do math
    
    // circle center y
    let cy = height / 2 + 1;
    // console.log("vertical center of circles:", cy);
    
    let radius = height / 2 - 2;
    // console.log("radius:", radius);

    // find middle of box
    let middle = width / 2;
    // console.log("middle:", middle);
    
    // each percentage maps to a certain amount of pixels and creates a grid
    let grid = (radius * 2) / 100;
    // console.log("grid:", grid);
    
    // left circle x
    let lcx = middle - grid * ( 50 - (match / 2) );
    // console.log("lcx:", lcx);
    
    // right circle x
    let rcx = middle + grid * ( 50 - (match / 2) );
    // console.log("rcx:", rcx);
    
		// clear
		ctx.clearRect(0, 0, width - 1, height);
    
		ctx.fillStyle = "#00d1ffaa";
    ctx.strokeStyle = "white";
    ctx.lineWidth = 1;
    
    // inside
    ctx.beginPath();
    ctx.arc(lcx, cy, radius, 0, 6.283185307179586);
    ctx.fill();
    // border
    ctx.beginPath();
    ctx.arc(lcx, cy, radius, 0, 6.283185307179586);
    ctx.stroke();
    
    // inside
		ctx.fillStyle = "#fff500aa";
    ctx.beginPath();
    ctx.arc(rcx, cy, radius, 0, 6.283185307179586);
    ctx.fill();
    // border
    ctx.beginPath();
    ctx.arc(rcx, cy, radius, 0, 6.283185307179586);
    ctx.stroke();

		ctx.fillStyle = "white";
    ctx.strokeStyle = "white";
    ctx.lineWidth = 1;
    
    // middle point
    // ctx.beginPath();
    // ctx.arc(middle, cy, 5, 0, 6.283185307179586);
    // ctx.fill();
    
    // let tcx = middle - 30;
    // let tcy = cy + 5;
    // ctx.font = '33px serif';
    // ctx.strokeStyle = "black";
    // ctx.strokeText(match + "%", tcx, tcy + 0.4);
    // ctx.font = '32px serif';
    // ctx.fillText(match + "%", tcx, tcy);
    
  }
}

</script>